import React, { useState } from 'react'
import { useHover } from '../../../hooks/useHover'
import Portal from '../../Portal/Portal';
import Overlay from '../../Overlay/Overlay';

const PotentialDisclaimer = ({ text }) => {
    const disclaimerButton = useHover();
    const iUnderstandButton = useHover();
    const [isOpenDisclaimer, setIsOpenDisclaimer] = useState(false);

    const handleOnClick = () => {
        setIsOpenDisclaimer(true);
    }

    const handleOnClickLeave = () => {
        iUnderstandButton.onMouseLeave();
        setIsOpenDisclaimer(false);
    }

    const disclaimerButtonStyle = {
        padding: '8px 16px',
        border: '1px solid black',
        background: disclaimerButton.isHover ? '#ccc' : '',
        cursor: 'pointer'
    }

    const disclaimerStyle = {
        background: "rgba(255, 255, 255, 1)",
        width: "60rem",
        border: "1px solid black",
        padding: "1rem 2rem",
        fontWeight: 500,
        fontFamily: 'Poppins'
    }

    const buttonStyle = {
        marginTop: '8px',
        padding: '8px 40px',
        backgroundColor: iUnderstandButton.isHover ? '#CCC' : '#EFEFEF',
        border: '1px solid black',
        fontWeight: 'bold',
        cursor: 'pointer'
    }

    return (
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '16px'}}>
            <div>Please Read:</div>
            <button style={disclaimerButtonStyle} onMouseEnter={disclaimerButton.onMouseEnter} onMouseLeave={disclaimerButton.onMouseLeave} onClick={handleOnClick}>Important Disclaimer</button>
            {isOpenDisclaimer && (
                <Portal>
                    <Overlay>
                        <div style={disclaimerStyle} onClick={(e) => e.stopPropagation()}>
                            <div style={{ whiteSpace: 'pre-wrap', maxHeight: '70vh', overflow: 'auto', marginBottom: '16px'}}>
                                <p>{text}</p>
                            </div>
                            
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button style={buttonStyle} onMouseEnter={iUnderstandButton.onMouseEnter} onMouseLeave={iUnderstandButton.onMouseLeave} onClick={handleOnClickLeave}>I UNDERSTAND</button>
                            </div>
                        </div>
                    </Overlay>
                </Portal>
            )}
        </div>
    )
}

export default PotentialDisclaimer